import { scaffolderPlugin } from '@backstage/plugin-scaffolder';
import { createScaffolderFieldExtension } from '@backstage/plugin-scaffolder-react';
import { CustomAutoGrowTextareaField } from './CustomAutoGrowTextareaField';

export const CustomAutoGrowTextareaFieldExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'CustomAutoGrowTextareaField',
    component: CustomAutoGrowTextareaField,
  }),
);
